/* @flow */

import React from 'react';
import UploadCounter from './UploadCounter';
import UploadItem from './UploadItem';

type Props = {
  uploads: List<RunningUpload>,
  runningCount: number,
};

const UploadList = ({ uploads, runningCount }: Props) => {
  const renderContent = () => {
    if (uploads.size) {
      return (
        <div className="ui stacked segments">
          {uploads.map(u => <UploadItem key={u.token} upload={u} />)}
        </div>
      );
    }

    return 'Aucun envoi en cours';
  };

  return (
    <div className="ui green segment">
      <UploadCounter count={runningCount} />
      {renderContent()}
    </div>
  );
};

export default UploadList;



// WEBPACK FOOTER //
// ./src/modules/bucket/screens/Upload/components/UploadList.js